import { useSnapshot } from 'valtio';
import type { MapObject } from '~/common/types';
import { useCivilDrawStore } from '../../../civilDrawStoreContext';
import { StyleMap } from './common';
import Style from './Style';

export default function ObjStyles() {
  const store = useCivilDrawStore();
  const { currentObject } = useSnapshot(store) as typeof store;

  if (!currentObject) return null;

  return (
    <div className="my-4 flex flex-col gap-4">
      <span className="text-base font-bold">Style</span>
      <StyleElements currentObject={currentObject} />
    </div>
  );
}

interface Props {
  currentObject: MapObject;
}

function StyleElements({ currentObject }: Props) {
  const { type, properties } = currentObject;

  const renderItems = (key: string) => {
    return StyleMap[key]?.map((style) => <Style key={`${key}-${style}`} style={style} />);
  };

  if (
    type === 'polygon' ||
    type === 'line' ||
    type === 'circle' ||
    type === 'marker' ||
    type === 'text' ||
    type === 'textV2' ||
    type === 'stamp'
  ) {
    return <>{renderItems(type)}</>;
  }

  if (type === 'arrow') {
    if (properties.subtype === 'metadata') {
      return <>{renderItems('arrow-metadata')}</>;
    }

    if (properties.showAsLeader) {
      return <>{renderItems('arrow-standard-as-leader')}</>;
    }

    return <>{renderItems('arrow-standard')}</>;
  }

  if (type === 'image') {
    if (properties.showBorder) {
      return <>{renderItems('image-with-border')}</>;
    }

    return <>{renderItems('image')}</>;
  }

  return null;
}
